<template>
  <v-container fluid>
    <RangeFilter 
      :end="dateEnd" 
      :start="dateStart" 
      @getDates="getDates" 
      :excludePeriod="excludePeriod"
      :defaultPeriod="defaultPeriod"
      :setDates="true"
      :disabled="loaded"
    />
    <v-row class="mt-5">
      <v-col cols="12" sm="6" md="3">
        <v-card class="calls-card rounded-lg elevation-2 d-flex flex-column"
          :loading="loaded" loader-height="1">
          <v-card-title class="calls-card-title pa-0">Totals</v-card-title>
          <v-card-text class="calls-text-card pa-0 mt-auto">
            <p class="mt-5"># Calls: {{ data.calls.total_calls }}</p>
            <hr class="mb-2"/>
            <p># CallRail (In): {{ data.calls.cr_in}}</p>

            <p># CallRail (Out): {{ data.calls.cr_out}}</p>

            <hr class="mb-2"/>
            <p>Hours: {{ Math.ceil(data.calls.gs_total_in_h + data.calls.call_rail_h_in) + Math.ceil(data.calls.gs_total_out_h + data.calls.call_rail_h_out)}}</p>
            <p>Hours (Out): {{Math.ceil(data.calls.gs_total_out_h + data.calls.call_rail_h_out)}}</p>
            <p>Hours (In): {{Math.ceil(data.calls.gs_total_in_h + data.calls.call_rail_h_in)}}</p>
            <hr class="mb-2">
            <p>Web Inquiries:
              <span>{{ this._.sumBy(data.inquires, function(o) { return o.count; }) }}</span>
            </p>
            <hr class="mb-2">
            <p>Created Quotes: {{data.copper.created_open}}</p>
            <hr class="mb-2">
            <p>Orders: {{data.calls.total_orders}}</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="calls-card rounded-lg elevation-2 d-flex flex-column"
          :loading="loaded" loader-height="1">
          <v-card-title class="calls-card-title pa-0">DialPad</v-card-title>
          <v-card-text class="calls-text-card pa-0 mt-auto">
            <p class="mt-5" style="margin: 0;">Calls (Out): {{ data.dialpad ? data.dialpad.calls_count : 0 }}</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="calls-card rounded-lg elevation-2 d-flex flex-column"
          :loading="loaded" loader-height="1">
          <v-card-title class="calls-card-title pa-0">CallRail</v-card-title>
          <v-card-text class="calls-text-card pa-0 mt-auto">
            <p class="mt-5" style="margin: 0;"># Calls: {{ data.calls.cl_answered + data.calls.cl_missed}}</p>
            <p style="font-size: 12pt; color: gray; padding: 0; margin: 0;"># &#60;= 40s: {{data.calls.cl_total_l40}}</p>
            <p style="font-size: 12pt; color: gray; padding: 0;"># &#62; 40s: {{data.calls.cl_total_m40}}</p>
            <hr class="mb-2"/>
            <p>Hours(In + Out): {{Math.ceil(data.calls.call_rail_h_out + data.calls.call_rail_h_in)}}</p>
            <hr class="mb-2"/>
            <hr v-if="data.call_by_type" class="mb-2"/>
            <p v-for="i in data.call_by_type" :key="i.type">{{ i.type }}s: {{ i.count }}</p>
            <p>Unique Voices: {{ data.calls.gs_voice_mail }}</p>
            <p>Unique Returned: {{data.calls.gs_returned}}</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="calls-card rounded-lg elevation-2 d-flex flex-column"
          :loading="loaded" loader-height="1">
          <v-card-title class="calls-card-title pa-0">Other</v-card-title>
          <v-card-text class="calls-text-card pa-0 mt-auto pt-5">

            <p class="card-sub-title">Web Inquiries</p>
            <p v-for="i in data.inquires" :key="i.subject">{{ i.subject }}: {{ i.count }}</p>
            <hr class="mb-2"/>

              <p class="card-sub-title">Newsletters</p>
              <p v-for="i in data.newsletters" :key="i.subject">{{ i.subject }}: {{ i.count }}</p>
              <hr class="mb-2"/>


            <p class="card-sub-title">Quotes</p>
            <p>Open Quotes: {{data.copper.open}}</p>
            <p>Converted Quotes: {{data.copper.converted}}</p>
            <p>Lost Quotes: {{data.copper.lost}}</p>

            <hr class="mb-2"/>
            <p class="card-sub-title">Orders</p>
            <p>Created by Call Center: {{data.calls.orders_created_call_center}}</p>
            <p>Created by Customer: {{data.calls.orders_created_customer}}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-5">
      <v-col cols="12" sm="6" md="4">
        <v-card class="calls-card rounded-lg elevation-2 d-flex flex-column"
          :loading="loaded" loader-height="1">
          <v-card-title class="calls-card-title pa-0">TizbiTechnology</v-card-title>
          <v-card-text class="calls-text-card pa-0 mt-auto">
            <p class="mt-5 font-weight-bold">Web Inquiries</p>
            <p class="ml-4">Get In Touch: {{ data.web_inq_touch_count || 0 }}</p>
            <p class="ml-4">Free Quote: {{ data.web_inq_freequote_count || 0 }}</p>
            <p class="ml-4">Have a question: {{ data.web_inq_question_count || 0 }}</p>
            <p class="ml-4">Contact us: {{ data.web_inq_contact_us_count || 0 }}</p>
            <p class="ml-4">Call back request: {{ data.web_inq_call_back_request_count || 0 }}</p>
            <hr class="my-3"/>
            <p class="font-weight-bold">Calls</p>
            <p class="ml-4">Calls Tizbi Technologies: {{ data.tizbi_techonology || 0 }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-none">
        <h2 class="mt-6">CallRail Calls</h2>
        <v-progress-linear
          indeterminate
          color="indigo"
          v-if="loaded"
        ></v-progress-linear>       
      <!-- <vue-chart style="height: 400px;" type="line" :data="chartData1" :options="options1"></vue-chart> -->
        <highcharts :options="chartOptions"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import moment from 'moment'
import RangeFilter from '@/components/filters/RangePicker'
import {Chart} from 'highcharts-vue'

export default {
  components: {
    RangeFilter,
    highcharts: Chart
  },
  data() {
    return {
      hideAnything: false,
      selected: [],
      data: {
        calls: {
          gs_total_call: null
        },
        copper: {
          created_open: null
        },
        web_inq_touch_count: 0,
        web_inq_freequote_count: 0,
        web_inq_question_count: 0,
        web_inq_contact_us_count: 0
      },
      historyChanged: [],
      userName: null,
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
                  Date.UTC(
                    new Date().getFullYear(), 
                    new Date().getMonth(),
                    1)).toISOString().substr(0, 10),
      excludePeriod: [],
      defaultPeriod: 4,
      loaded: false,
      chartOptions: {
        chart: {
          height: 700,
          type: 'areaspline',
          zoomType: 'x'
        },
        title: {
          text: null
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
        },
        tooltip: {
            formatter: function () {
                var tip = "<b>" + moment(new Date(this.x)).format('MM/DD/YYYY') + "</b>";
                tip += "<br/><span>"+ this.series.name + "</span>: " + this.y + "<br/>";
                return tip;
            },
        },
        xAxis: {
          gridLineWidth: 1,
          minPadding: 0,
          maxPadding: 0,
          categories: [],
          crosshair: true,
          labels: {
            formatter: function() {
                return moment(new Date(this.value)).format('MM/DD/YYYY')
            },
          },
          type: 'datetime',
          tickPositioner: function () {
            let positions = [],        
                tick = Math.floor(this.dataMin),
                increment = Math.ceil((this.dataMax - this.dataMin) / 10)
          
            if (this.dataMax === 0) {
              positions = [0]
            } else if (this.dataMax !== null && this.dataMin !== null) {
                for (tick; tick  <= this.dataMax; tick += increment) {
                  positions.push(tick)
                }
            }
            return positions
          }
        },
        yAxis: {
          crosshair: true,
          title: {
            text: 'Count'
          },
          labels: {
            formatter: function() {
                return this.value;
            },
          },
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.05,
            marker: {
              symbol: 'circle',
              radius: 3
            }
          }
        },
        series: [],
      },
      colors: [
        {color: '#6372c3', bg_color: 'rgba(99, 114, 195, 0.4)'},
        {color: '#82ddb8', bg_color: 'rgba(130, 221, 184, 0.4)'},
        {color: '#d87691', bg_color: 'rgba(216, 118, 145, 0.4)'}   
      ]
    }
  },
  watch: {

  },
  computed: {
    total_in() {
      let sub = this.data.calls.gs_total_in - (this.data.calls.cl_answered + this.data.calls.cl_missed)

      if (sub < 0) {
        return "NA"
      }

      return sub
    }
  },
  mounted() {
    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }
    if (localStorage.getItem('fromCounterPage')) {
      let data = JSON.parse(localStorage.getItem('fromCounterPage'))
      this.dateStart = data.dateStart
      this.dateEnd = data.dateEnd
      this.defaultPeriod = data.defaultPeriod
      localStorage.removeItem('fromCounterPage')
    }

    this.loaded = true
    axios
        .get('/username')
        .then(response => (this.userName = response.data))
    this.applyFilters()
  },
  methods: {
    getDates(dates){
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
      this.applyFilters()
    },
    applyFilters() {
      this.loaded = true
      axios
          .get('/dashboard/call-center/' + this.dateStart + '/' + this.dateEnd)
          .then(response => {
            this.data = response.data

            this.loaded = false

            if (this.data?.call_stat.length === 0) {
              this.chartOptions.series[0] = {}
              this.chartOptions.series[1] = {}
              this.chartOptions.series[2] = {}
              this.chartOptions.xAxis.categories = []
            } else {
                this.chartOptions.series[0] = {
                    name: '# Calls',
                    data: this.data.call_stat.map(e =>e.total_call),
                    color: this.colors[0].color,
                    borderWidth: 2,
                  }
                this.chartOptions.series[1] = {
                    name: '# Calls less 40s',
                    data: this.data.call_stat.map(e =>e.less_40s),
                    color: this.colors[1].color,
                    borderWidth: 2,
                  }
                this.chartOptions.series[2] = {
                    name: '# Calls with Relevance less 7',
                    data: this.data.call_stat.map(e =>e.less_7_rel),
                    color: this.colors[2].color,
                    borderWidth: 2,
                }
                this.chartOptions.xAxis.categories = this.data.call_stat.map(e=> e.dt)
            }
          })
    }
  }
}
</script>

<style scoped>
  .calls-card-title{
    background-color: #6baf6b;
    border-radius: 0!important;
    color:white!important;
    text-align: center!important;
    display: block;
  }
  .calls-text-card {
    font-size: 1.2em;
    text-align: left;
    color: black !important;
  }
  .calls-card {
    min-height: 130px;
    padding: 20px 40px;
  }
  .calls-card-title {
    font-size: 0.9em;
    word-break: keep-all;
  }
  .card-sub-title{
    color: #4747d3;
  }
  @media (min-width: 960px) and (max-width: 980px) {
    .calls-card-title {
      word-break: break-all;
    }
  }

</style>